<template>
    <b-card no-body>
        <b-card-header class="pb-50">
            <h5>Фильтры</h5>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                    <b-form-group
                        label="Пользователь"
                        class="flex-grow-1"
                        description="Выберите пользователя"
                    >
                        <choose-user-field
                                v-model="formModel['user']"
                                @input="val => formModel['user'] = val"
                        ></choose-user-field>
                    </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                    <b-form-group
                        label="Тип контента"
                        class="flex-grow-1"
                        description="Выберите тип контента"
                    >
                        <choose-content-type-field
                                v-model="formModel['content_type']"
                                @input="val => formModel['content_type'] = val"
                        ></choose-content-type-field>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
    import {
        BCard,
        BCardHeader,
        BCardBody,
        BRow,
        BCol,
        BFormGroup } from 'bootstrap-vue'
    import { watch, ref } from '@vue/composition-api'

    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChooseContentTypeField from "../../../content_type/components/ChooseContentTypeField";


    export default {

        components:{
            ChooseContentTypeField,
            BRow, BCol,
            BCard, BCardHeader, BCardBody,
            BFormGroup,

            ChooseUserField,
        },


        setup(_,{emit}) {


            const formModel = ref({
                user: '',
                content_type: ''
            })


            watch(formModel.value, (value) => emit('filtered', value), { deep: true })

            return {
                formModel,
            }
        },
    }
</script>
